var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowUnderline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 373,
    height: 14,
    viewBox: "0 0 373 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.018 7.75329C296.664 0.943936 222.068 4.69997 148.529 3.46853C99.9009 2.64467 51.2694 0.666412 2.67654 0.00116962C1.21965 -0.0165846 0.021346 1.14644 0.000980427 2.60922C-0.0185054 4.07199 1.14794 5.27055 2.60395 5.2883C51.1915 5.95354 99.8177 7.9318 148.44 8.75566C221.848 9.98709 296.303 6.22221 369.525 13.0227C370.977 13.1551 372.261 12.089 372.402 10.635C372.534 9.18106 371.461 7.89441 370.018 7.75329Z",
    fill: "#EBFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowUnderline);
export default __webpack_public_path__ + "static/media/yellow-underline.dc26b5a091c9949c4644749978bcfeec.svg";
export { ForwardRef as ReactComponent };